import { IAgencyNumberConfig, IAgencyNumbers, IDatasetDeterminationConfig } from '../store/configurations.types'

export const agencyNumberConfigToAgencyNumber = (agencyNumberConfig: Array<IAgencyNumberConfig>): IAgencyNumbers => {
  const agencyNumbers: IAgencyNumbers = {}
  agencyNumberConfig.forEach((datasetConfig) => {
    agencyNumbers[datasetConfig.dataset] = datasetConfig.agencyNumber
  })

  return agencyNumbers
}

export const updateDatasetDeterminationConfig = (
  datasetDeterminationConfig: IDatasetDeterminationConfig,
  datasetsList: Array<string>
): IDatasetDeterminationConfig => {
  const updatedDatasets = datasetDeterminationConfig.datasets.map((dataset) => {
    if (datasetsList.includes(dataset.dataset || '')) {
      dataset.includeInExport = 1
    } else {
      dataset.includeInExport = 0
    }

    return dataset
  })

  return { ...datasetDeterminationConfig, datasets: updatedDatasets }
}
